
  export const env ={
    REACT_APP_MAIN_URL: "http://localhost:4001",
    REACT_APP_API_URL: "http://localhost:4001"
  }
 